import styled from 'styled-components';

import { breakpoints } from '../../../lib/constants';

const StyledBox = styled.div`
  margin: auto;

  hr {
    border-color: var(--color-border-muted);
    border-width: 0.5px;
  }

  p, li {
    color: var(--color-text-secondary);
  }
`;

export const Info = styled(StyledBox)`
  border: 1px solid var(--color-border-default);
  border-top: 3px solid var(--color-text-secondary);
  padding: 20px;

  ul {
    list-style-type: none;
  }

  s-icon {
    line-height: 1.5rem
  }

  p, li {
    color: initial;
  }
`;

export const LightBoxOutline = styled(Info)`
  border: 1px solid var(--color-border-default);
  margin-top: 20px;
  width: fit-content;
  display: inline-block;

  li, i, h4 {
    font-size: .875rem;
  }

  p {
    margin: unset;
  }

  ul {
    list-style: none;
    margin-left: unset;
    margin-top: 1.0em;
  }

  li::before {
    content: "•";
    padding-right: 8px;
    font-size: 18px;
    color: var(--color-brand-orange);
  }

  @media (max-width: ${breakpoints.phone}px) {
    width: 100%;
  }
`;

export const GrayBox = styled(StyledBox)`
  background-color: var(--color-surface-muted);
  padding: 20px;
  && *:not(a) {
    color: var(--color-text-primary);
  }

  && button:not(a) {
    color: var(--color-accent-text);
  }
`;

export const ReviewBox = styled(StyledBox)`
background-color: var(--color-surface-muted);
padding: 20px;
p {
  color: var(--color-text-primary);
};
hr {
  border-color: var(--color-border-default);
  border-width: 0.5px;
}
`;
